import type { SchedulesManager } from "@/pages/human-resources/time-management/business/SchedulesManager.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import { SchedulesManagerContext } from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/SchedulesManagerProvider.tsx";

export default function useSchedulesManager(): SchedulesManager {
  return useDefinedContextValue(SchedulesManagerContext);
}
